// extracted by mini-css-extract-plugin
export default {"root":"SummaryTitle_root__WEp3O","placeHolderShimmer":"SummaryTitle_placeHolderShimmer__PkAGF"};